import { app } from 'app/app';
import { AppModule } from 'app/module';
import { JobDetailContent } from 'module/jobDetailContent/main';
import { mediaQueries } from 'util/mediaQueries';
import { handleBounce } from 'util/bounce';
import Template from './template.hbs';
import './styles.scss';

let yCoordinate = 0;
const TABNAV_MEMO_INDEX = 2;

export class JobDetail extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    getPropsFromDom() {
        return {
            isSeamless: this.dom.el.getAttribute('data-is-seamless') === 'true',
        };
    }

    ready() {
        app.events.on('onWindowResize', () => this.onWindowResize());
    }

    domBindings() {
        return {
            jobDetailContent: '.m-jobDetailContent',
            closeTriggerContainer: '.m-jobDetail__close',
            closeTrigger: '.m-jobDetail__closeTrigger',
            container: '.m-jobDetail__container',
        };
    }

    domEvents() {
        if (this.dom.closeTrigger) {
            this.dom.closeTrigger.addEventListener('click', () => this.closeModalViaClick());
        }

        if (mediaQueries.isMobile()) {
            this.dom.container.addEventListener('touchstart', (e) => {
                yCoordinate = e.touches[0].clientY;
            });

            this.dom.container.addEventListener('touchmove', (e) => {
                e.stopPropagation();
                yCoordinate = handleBounce(e, yCoordinate);
            });
        }
    }

    subs() {
        if (this.dom.jobDetailContent) {
            this.jobDetailContent = new JobDetailContent(this.dom.jobDetailContent);
        }
    }

    subEvents() {
        if (this.dom.jobDetailContent) {
            this.jobDetailContent.events.on('closeModal', () => {
                this.closeModal();
            });
            this.jobDetailContent.events.on('removeCloseTriggerStyles', () => {
                this.removeCloseTriggerStyles();
            });
            this.jobDetailContent.events.on('addCloseTriggerStyles', () => {
                this.addCloseTriggerStyles();
            });
            this.jobDetailContent.events.on('pushState', () => this.events.emit('pushState'));
            this.jobDetailContent.events.on('addShareModalStyles', () => {
                if (mediaQueries.isMobile()) {
                    this.dom.container.style.overflowY = 'hidden';
                    this.dom.closeTriggerContainer.style.zIndex = 'auto';
                } else {
                    this.events.emit('addShareModalStyles');
                }
            });
            this.jobDetailContent.events.on('removeShareModalStyles', () => {
                if (mediaQueries.isMobile()) {
                    this.dom.container.style.overflowY = 'scroll';
                    this.dom.closeTriggerContainer.style.zIndex = '104';
                } else {
                    this.events.emit('removeShareModalStyles');
                }
            });
            this.jobDetailContent.events.on('toggleContent', () => {
                this.toggleContent();
            });
            this.propagateEvents(this.jobDetailContent, 'removeModalStyle');
            this.propagateEvents(this.jobDetailContent, 'addModalStyle');
            this.propagateEvents(this.jobDetailContent, 'jobContentLoaded');
            this.propagateEvents(this.jobDetailContent, 'jobContentLoading');
            this.propagateEvents(this.jobDetailContent, 'openDeleteModal');
            this.propagateEvents(this.jobDetailContent, 'showSnackbar');
            this.propagateEvents(this.jobDetailContent, 'memoSaved');
            this.propagateEvents(this.jobDetailContent, 'memoDeleted');
            this.propagateEvents(this.jobDetailContent, 'showMemoOverlay');
            this.propagateEvents(this.jobDetailContent, 'hideMemoOverlay');
        }
    }

    toggleContent() {
        this.events.emit('jobContentLoading');
        this.jobDetailContent.render();
    }

    openModal() {
        this.updateProps({ modalOpen: true }, true);
        this.events.emit('addModalStyle');
    }

    closeModal() {
        this.updateProps({ modalOpen: false }, true);
        this.events.emit('removeModalStyle');
    }

    closeModalViaClick() {
        if (this.jobDetailContent.getActiveTab() === TABNAV_MEMO_INDEX
            && !this.jobDetailContent.memoContentSimilar()) {
            this.events.emit('openSaveModal');
        } else {
            window.history.back();
        }
    }

    onWindowResize() {
        if (!mediaQueries.isMobile() && this.jobDetailContent.props.modalOpen) {
            this.closeModal();
        }
    }

    removeCloseTriggerStyles() {
        // Wait for animation to be done, before removing styles
        setTimeout(() => {
            if (this.dom.closeTriggerContainer) {
                this.dom.closeTriggerContainer.style.backgroundColor = 'transparent';
                this.dom.closeTriggerContainer.style.borderBottomStyle = 'none';
            }
        }, 500);
    }

    addCloseTriggerStyles() {
        this.dom.closeTriggerContainer.style.backgroundColor = '#ffffff';
        this.dom.closeTriggerContainer.style.borderBottomStyle = 'solid';
    }

    isShareModalOpen() {
        return this.jobDetailContent.isShareModalOpen();
    }

    closeShareModal() {
        this.jobDetailContent.closeShareModal();
    }

    openShareModal() {
        this.jobDetailContent.openShareModal();
    }

    allowPointerEvents() {
        if (this.jobDetailContent) {
            this.jobDetailContent.allowPointerEvents();
        }
    }

    sendShowEvents() {
        if (this.jobDetailContent) this.jobDetailContent.sendShowEvents();
    }

    afterRender() {
        if (this.props.openMemoTab && this.jobDetailContent.tabNav) {
            this.jobDetailContent.tabNav.toggleTab(TABNAV_MEMO_INDEX);
        }
    }

    deleteMemo() {
        if (this.jobDetailContent) {
            this.jobDetailContent.deleteMemo();
        }
    }

    saveMemo() {
        if (this.jobDetailContent) {
            this.jobDetailContent.saveMemo();
        }
    }

    memoContentSimilar() {
        if (this.jobDetailContent) {
            return this.jobDetailContent.memoContentSimilar();
        }
        return false;
    }

    getActiveTab() {
        if (this.jobDetailContent) {
            return this.jobDetailContent.getActiveTab();
        }
        return false;
    }

    getTextareaValue() {
        if (this.jobDetailContent) {
            return this.jobDetailContent.getTextareaValue();
        }
        return false;
    }
}
